(() => {
  const lang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
  if (!lang.startsWith("en")) return;

  const isProduct = document.body.classList.contains("template-product");
  const isCart = document.body.classList.contains("template-cart");
  if (!isProduct && !isCart) return;

  const map = window.PC_PRODUCT_OPTIONS_TRANSLATIONS || {};
  const prefixMap = window.PC_PRODUCT_OPTIONS_PREFIX_TRANSLATIONS || {};

  const replacements = Object.entries(map).sort((a, b) => b[0].length - a[0].length);
  const prefixReplacements = Object.entries(prefixMap).sort((a, b) => b[0].length - a[0].length);

  const decodeHtmlEntities = (str) => {
    if (!str || typeof str !== "string") return str;
    const el = document.createElement("textarea");
    el.innerHTML = str;
    return el.value;
  };

  const shouldSkipTextNode = (node) => {
    const p = node.parentNode;
    if (!p || p.nodeType !== 1) return false;
    const tag = p.tagName;
    return tag === "SCRIPT" || tag === "STYLE" || tag === "NOSCRIPT";
  };

  const translateString = (input) => {
    if (!input || typeof input !== "string") return input;
    const decoded = decodeHtmlEntities(input);
    let out = decoded;

    for (const [from, to] of replacements) {
      if (!from) continue;
      if (out.includes(from)) out = out.split(from).join(to);
    }
    for (const [from, to] of prefixReplacements) {
      if (!from) continue;
      if (out.startsWith(from)) out = to + out.slice(from.length);
    }

    return out;
  };

  const walkTextNodes = (root, onTextNode) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (shouldSkipTextNode(node)) return NodeFilter.FILTER_REJECT;
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    let n;
    while ((n = walker.nextNode())) onTextNode(n);
  };

  const translateAttributes = (root) => {
    if (!root.querySelectorAll) return;
    const nodes = root.querySelectorAll("[aria-label],[placeholder]");

    for (const el of nodes) {
      const aria = el.getAttribute("aria-label");
      if (aria) {
        const next = translateString(aria);
        if (next !== aria) el.setAttribute("aria-label", next);
      }

      if (typeof el.placeholder === "string" && el.placeholder) {
        const next = translateString(el.placeholder);
        if (next !== el.placeholder) el.placeholder = next;
      }
    }
  };

  const getTranslationRoots = () => {
    const roots = [];
    const seen = new Set();
    document.querySelectorAll("[class*='product-customizer']").forEach((el) => {
      if (el && !seen.has(el)) {
        seen.add(el);
        roots.push(el);
      }
    });
    return roots.length ? roots : null;
  };

  const translateNow = () => {
    const roots = getTranslationRoots();
    if (!roots) return;

    for (const root of roots) {
      walkTextNodes(root, (node) => {
        const before = node.nodeValue;
        const after = translateString(before);
        if (after !== before) node.textContent = after;
      });
      translateAttributes(root);
    }
  };

  let debounceId = null;
  const scheduleTranslate = () => {
    if (debounceId) window.clearTimeout(debounceId);
    debounceId = window.setTimeout(() => {
      debounceId = null;
      translateNow();
    }, 120);
  };

  // Initial runs (in case app rendered before observer starts).
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      translateNow();
      window.setTimeout(translateNow, 1500);
    });
  } else {
    translateNow();
    window.setTimeout(translateNow, 1500);
  }

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type !== "childList") continue;
      if (!m.addedNodes || m.addedNodes.length === 0) continue;
      scheduleTranslate();
      return;
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

